import React from 'react';
import Tippy from '@tippyjs/react/headless';
import { useTheme } from '@iq/react-components';

const Tooltip = ({ content, children, options, placement, disabled, styles }) => {
  const theme = useTheme();

  if (!content) {
    return children;
  }

  return (
    <Tippy
      // visible={true}
      render={(attrs) => (
        <div
          {...attrs}
          id="tooltip"
          className={`tooltip-box theme-${theme}`}
          tabIndex={-1}
          style={styles}
        >
          {content}
        </div>
      )}
      placement={placement || 'top-start'}
      {...options}
      disabled={disabled}
    >
      {children}
    </Tippy>
  );
};

export default Tooltip;
